/* I didn't come up with a better place for this, so it's gonna be here */

export const DEFAULT_CATEGORY: "category1" | "category2" | "category3" =
  (typeof ryb_connect_classes_data !== "undefined" &&
    ryb_connect_classes_data?.filters?.wizard_category_map) ||
  "category2";

export const APP_VERSION = process.env.APP_VERSION || "1.3.5";
